/*
 *
 * Checkpoint Parking Page constants
 *
 */

export const CHECKPOINT_PARKING_DATA_TABLE = 'CheckpointParkingDataTable';
